import { render } from "./CertAlcoholOngoing.vue?vue&type=template&id=8d894a2a&scoped=true"
import script from "./CertAlcoholOngoing.vue?vue&type=script&lang=js"
export * from "./CertAlcoholOngoing.vue?vue&type=script&lang=js"

import "./CertAlcoholOngoing.vue?vue&type=style&index=0&id=8d894a2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d894a2a"]])

export default __exports__